export default "__VITE_ASSET__CBAW4J9y__"